// extracted by mini-css-extract-plugin
module.exports = {"tokenBalance":"ProjectBalance_tokenBalance__1YjoP","tokenTicker":"ProjectBalance_tokenTicker__2n2sF"};